import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppErrorBoundary } from '../AppErrorBoundary';
import { AppSidebar } from './AppSidebar';
import { useAppShell } from './AppShellContext';
import { RedirectAuth } from './RedirectAuth';
import { Route, Switch } from 'react-router-dom';
import { MessageSignIn } from './MessageSignIn';
import { MessageAuthError } from './MessageAuthError/MessageAuthError';
import { AccountVerification } from './AccountVerification';
import { ResponsiveMode, ScrollablePane, Stack, useResponsiveMode, } from '@fluentui/react';
import { AppSidebarMenu } from './AppSidebarMenu';
import { useRef } from 'react';
import { APPBAR_HEIGHT } from '../Appbar';
import { useAppThemeConnector } from '../theme/useAppThemeConnector';
/**
 * Overall layout for the AppShell component.
 */
export const AppShellLayout = ({ AppBar, MessageBarList, children, strings, supportEmailUrl, }) => {
    useAppThemeConnector();
    const { appShellId } = useAppShell();
    const ref = useRef(null);
    const viewportWidth = useResponsiveMode(ref);
    const isViewportWidthLarge = viewportWidth >= ResponsiveMode.xLarge;
    return (_jsx("div", Object.assign({ style: {
            height: '100%',
            overflow: 'hidden',
        }, ref: r => (ref.current = r), id: appShellId }, { children: _jsxs(Stack, Object.assign({ horizontalAlign: 'stretch', verticalAlign: 'stretch', verticalFill: true }, { children: [AppBar && (_jsxs("header", Object.assign({ role: 'banner', style: {
                        height: APPBAR_HEIGHT,
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'stretch',
                        alignItems: 'stretch',
                    } }, { children: [_jsx(AppSidebarMenu, { isViewportWidthLarge: isViewportWidthLarge }), _jsx(AppBar, {})] }))), _jsxs(Stack, Object.assign({ horizontal: true, horizontalAlign: 'stretch', verticalAlign: 'stretch', grow: 3, styles: {
                        root: {
                            height: '100%',
                        },
                        inner: {
                            height: '100%',
                            overflow: 'hidden',
                        },
                    } }, { children: [_jsx(AppSidebar, { isViewportWidthLarge: isViewportWidthLarge }), _jsxs(Stack, Object.assign({ verticalAlign: 'stretch', horizontalAlign: 'stretch', role: 'main', id: 'main-content', grow: 3, styles: {
                                inner: {
                                    height: '100%',
                                    overflow: 'hidden',
                                },
                            } }, { children: [_jsxs("div", { children: [_jsx(AccountVerification, {}), _jsx(MessageAuthError, {}), _jsx(MessageSignIn, Object.assign({}, strings === null || strings === void 0 ? void 0 : strings.messageSignIn)), MessageBarList && _jsx(MessageBarList, {})] }), _jsx("div", Object.assign({ style: {
                                        width: '100%',
                                        height: '100%',
                                        flexGrow: 11,
                                        justifyContent: 'stretch',
                                    } }, { children: _jsx("div", Object.assign({ style: {
                                            // Catch injected scrollable panes.
                                            position: 'relative',
                                            height: '100%',
                                        } }, { children: _jsx(ScrollablePane, { children: _jsxs(Switch, { children: [_jsx(Route, Object.assign({ path: '(.*/auth)' }, { children: _jsx(RedirectAuth, {}) })), _jsx(Route, { children: _jsx(AppErrorBoundary, Object.assign({}, { supportEmailUrl }, { children: children })) })] }) }) })) }))] }))] }))] })) })));
};
